module.exports = __webpack_public_path__ + "img/WAONFC.ba447b64.png";